import React, { useState } from 'react';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { FiMenu, FiX } from 'react-icons/fi';

const Wrapper = styled.div`
  position: fixed;
  top: 1.2rem;
  right: 1.5rem;
  z-index: 2000;

  @media (min-width: 769px) {
    display: none;
  }
`;

const CandyBox = styled.button`
  background: ${({ theme }) => theme.navBackground};
  border: 1px solid ${({ theme }) => theme.line || 'rgba(12,12,12,0.12)'};
  padding: 0.65rem;
  border-radius: 0;
  box-shadow: none;
  cursor: pointer;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.accent || theme.text};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  right: ${({ open }) => (open ? '0' : '-100%')};
  width: 70%;
  height: 100vh;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  box-shadow: -2px 0 12px rgba(0,0,0,0.1);
  transition: right 0.3s ease;
  padding: 4rem 2rem;
  z-index: 1500;

  ul {
    list-style: none;
    padding: 0;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    a {
      color: ${({ theme }) => theme.text};
      text-decoration: none;
      font-size: 1rem;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }
  }
`;

function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Wrapper>
        <CandyBox onClick={() => setOpen(prev => !prev)}>
          {open ? <FiX /> : <FiMenu />}
        </CandyBox>
      </Wrapper>

      <MenuOverlay open={open}>
        <ul onClick={() => setOpen(false)}>
          <li><a href="#hero">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#experience">Experience</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </MenuOverlay>
    </>
  );
}

export default MobileNav;
